import React from 'react'

export const DigitalSolutionGC = props => {
  return (
    <div className="digital_solution_description">
      <p>
        <b>Ecos (Campus):</b> Esta solução oferece ao colégio a excelência do sistema de ensino Ecos com a aplicação da metodologia GAD - Gestão de Aprendizagem por Dados no desenho curricular, planejamento pedagógico, acompanhamento de performance dos estudantes e geração e gestão de dados e evidências de aprendizagem. A plataforma digital desta solução é o  Campus.
      </p>
    </div>
  )
}
